import { frontendURL } from '../../../helper/URLHelper';
import CommentsIndex from './pages/CommentsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.COMMENT_MANAGEMENT,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

// Unlike companies/routes.js, the parent-plus-child-of-the-same-component
// trick isn't used here: CommentsIndex renders its own header, tab bar and
// <router-view>, so pairing it as both parent and child would mount it
// twice (a duplicated header/tab bar nested inside itself). Each tab is a
// plain top-level leaf route pointing at the same shell component instead.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/comments'),
    name: 'comments_dashboard_index',
    component: CommentsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/comments/posts'),
    name: 'comments_dashboard_posts',
    component: CommentsIndex,
    // comment_management and post_publishing clear Meta App Review
    // independently, so this route is reachable under either -- a single
    // meta.featureFlag string can't express that OR. sidebar/provider.js's
    // isAllowed()/shouldShow() DOES enforce this field for sidebar
    // visibility (routes/index.js's router guard does not). Leaving it
    // undefined neutralizes that sidebar check, so the explicit OR in
    // Sidebar.vue's menu construction is what actually decides.
    meta: { ...commonMeta, featureFlag: undefined },
  },
];
